const initialState = {
  newOrganizationSapForm: false,
  sapContract: null,
  sapCode: null,
  sapNum: null,
  sapInstitution: '',
  gender: '',
};
export default initialState;
